import React, { memo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Markdown, Message } from 'barnyard/components';
import { Row } from 'barnyard/layouts';


const classPrefix = 'rCorporate--RuleForm';

const RuleForm = (props) => {
  const {
    onSubmit,
    onReset,
    children,
    isSubmitting,
    button,
    title,
    description,
    disabled,
    error,
  } = props;

  return (
    <div className={classPrefix}>
      <div className={`${classPrefix}__titles`}>
        <h3>{title}</h3>
        {error && (
          <Message
            className='u-marginBottom10'
            color='danger'
            border={true}
            message={error}
          />
        )}
        <Markdown markdown={description} Node='h4' />
      </div>
      <form onSubmit={onSubmit}>
        {children}
        <Row justify='end'>
          <Button node='a' color='naked' onClick={onReset} className='u-marginRight20'>
            Reset
          </Button>
          <Button disabled={disabled} loading={isSubmitting} value='submit' color='primary'>
            {button}
          </Button>
        </Row>
      </form>
    </div>
  );
};

RuleForm.propTypes = {
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  children: PropTypes.node,
  isSubmitting: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  button: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default memo(RuleForm);

